import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Menu,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material'
import { SquareRounded } from '@mui/icons-material'

const FsPtInteractiveButtons = ({ onExportPDF, onExportCSV }: any) => {
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [exportOptions, setExportOptions] = useState([1, 2, 3, 4, 5])
  const [exportLanguage, setExportLanguage] = useState('de')

  const handleExportOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleExportClose = () => {
    setAnchorEl(null)
  }

  return (
    <Stack direction="row" alignItems="center">
      <Button variant="outlined" onClick={onExportCSV}>
        {t('export.as.csv')}
      </Button>
      <Button variant="contained" sx={{ ml: 2 }} onClick={handleExportOpen}>
        {t('export.as.pdf')}
      </Button>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleExportClose}
      >
        <Box py={2} px={4}>
          <Typography className="font-semibold" color="primary">
            {t('pt.results.export.pdf.title')}
          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked
                  checkedIcon={<SquareRounded />}
                  disableRipple
                  sx={{ cursor: 'default' }}
                />
              }
              label={t('pt.results.export.pdf.1')}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={[2, 3, 4, 5].every((o) => exportOptions.includes(o))}
                  onClick={() =>
                    [2, 3, 4, 5].every((o) => exportOptions.includes(o))
                      ? setExportOptions(exportOptions.filter((eo) => eo === 1))
                      : setExportOptions([...exportOptions, 2, 3, 4, 5])
                  }
                />
              }
              label={t('pt.results.export.pdf.all')}
            />
            <FormControlLabel
              sx={{ ml: 2 }}
              control={
                <Checkbox
                  checked={exportOptions.includes(2)}
                  onClick={() =>
                    exportOptions.includes(2)
                      ? setExportOptions(exportOptions.filter((eo) => eo !== 2))
                      : setExportOptions([...exportOptions, 2])
                  }
                />
              }
              label={t('pt.results.export.pdf.2')}
            />
            <FormControlLabel
              sx={{ ml: 2 }}
              control={
                <Checkbox
                  checked={exportOptions.includes(3)}
                  onClick={() =>
                    exportOptions.includes(3)
                      ? setExportOptions(exportOptions.filter((eo) => eo !== 3))
                      : setExportOptions([...exportOptions, 3])
                  }
                />
              }
              label={t('pt.results.export.pdf.3')}
            />
            <FormControlLabel
              sx={{ ml: 2 }}
              control={
                <Checkbox
                  checked={exportOptions.includes(4)}
                  onClick={() =>
                    exportOptions.includes(4)
                      ? setExportOptions(exportOptions.filter((eo) => eo !== 4))
                      : setExportOptions([...exportOptions, 4])
                  }
                />
              }
              label={t('pt.results.export.pdf.4')}
            />
            <FormControlLabel
              sx={{ ml: 2 }}
              control={
                <Checkbox
                  checked={exportOptions.includes(5)}
                  onClick={() =>
                    exportOptions.includes(5)
                      ? setExportOptions(exportOptions.filter((eo) => eo !== 5))
                      : setExportOptions([...exportOptions, 5])
                  }
                />
              }
              label={t('pt.results.export.pdf.5')}
            />
          </FormGroup>
          <Typography className="font-semibold" color="primary" mt={2}>
            {t('pt.results.export.pdf.lang.title')}
          </Typography>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={exportLanguage}
              onChange={(event) => setExportLanguage(event.target.value)}
              row
            >
              <FormControlLabel value="de" control={<Radio />} label="Deutsch" />
              <FormControlLabel value="en" control={<Radio />} label="English" />
            </RadioGroup>
          </FormControl>
          <Stack direction="row" alignItems="center" justifyContent="flex-end" mt={1}>
            <Button variant="outlined" onClick={handleExportClose}>
              {t('cancel')}
            </Button>
            <Button
              variant="contained"
              sx={{ ml: 2 }}
              disabled={exportOptions.length === 0}
              onClick={() => {
                onExportPDF(exportOptions, exportLanguage)
                handleExportClose()
              }}
            >
              {t('export')}
            </Button>
          </Stack>
        </Box>
      </Menu>
    </Stack>
  )
}

export default FsPtInteractiveButtons
